/**
 * Cardio goals historically used `session` (singular) in some UIs and `sessions` in others.
 * Normalize for display and comparisons.
 */
export function getCardioSessionsPerWeek(goal) {
  if (!goal || typeof goal !== "object") return null;
  const raw = goal.sessions ?? goal.session;
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : raw;
}
